import { requests, mainApiRoot } from './index'

export const KeywordFinder = {
  get: payload => requests.post(mainApiRoot, '/keyword-finder/suggestions', payload),
  getSerp: (keywordId, keywordInfoId) =>
    requests.post(mainApiRoot, `/keyword-finder/${keywordInfoId}/load-serp/${keywordId}`),
  getLocales: () => requests.get(mainApiRoot, '/keyword-finder/locations'),
  getSuggestions: payload => requests.post(mainApiRoot, '/keyword-finder/ranked', payload),
  getPrevious: historyId => requests.get(mainApiRoot, `/keyword-finder/history/${historyId}`),
  related: payload => requests.post(mainApiRoot, '/keyword-finder/related', payload),
  ideas: payload => requests.post(mainApiRoot, '/keyword-finder/ideas', payload),
  getHistory: () => requests.get(mainApiRoot, '/keyword-finder/history'),
  del: historyId => requests.del(mainApiRoot, `/keyword-finder/history/${historyId}`)
}
